import React from "react";
import "../../assets/css/home.css";
import { useLocation, useParams } from "react-router-dom";
import { Button, styled } from "@mui/material";
import { ChevronLeft } from "@mui/icons-material";

const ColorButton = styled((props) => <Button variant="outlined" {...props} />)(
  {
    color: "rgb(0,105,255)",
    borderRadius: "30px",
    height: "50px",
  }
);

function capitalizeFirstLetter(string) {
  const normalized = String(string || "").replace(/_/g, " ");
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

const IntegrationHeader = (props) => {
  const { integration } = useParams();
  const location = useLocation();
  const isPopupMode = new URLSearchParams(location.search).get("popup") === "1";
  const isGoogleCalendarPage = integration === "google_calendar";
  const DisplayComponent = props?.display?.default || props?.display;
  const canRenderDisplay = typeof DisplayComponent === "function";

  if (isPopupMode) {
    return canRenderDisplay ? (
      <DisplayComponent logout={props.logout ? props.logout : ""} data={props.data} />
    ) : (
      <div style={{ padding: 24 }}>
        <h3>Integration page is unavailable.</h3>
      </div>
    );
  }

  return (
    <div style={{ position: 'relative' }}>
      <div className="content-header" style={{ height: "100px" }}>
        <div className="content-head" style={{ justifyContent: "center" }}>
          <div className="flex align">
            <div className="flex">
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                  width: "100%",
                  flex: 1,
                }}
              >
                <ColorButton
                  href={
                    integration ? "/biz/integrations" : "/biz/bookingtypes"
                  }
                  startIcon={<ChevronLeft />}
                >
                  Back
                </ColorButton>
              </div>
            </div>
            <h2
              style={{ flex: integration && 4.5 }}
              className={"input-label justify flex"}
            >
              {integration
                ? capitalizeFirstLetter(integration) + " Information"
                : "Integrations"}
            </h2>
            <div className="flex"></div>
          </div>
        </div>
      </div>
      {canRenderDisplay ? (
        <DisplayComponent
          logout={props.logout ? props.logout : ""}
          data={props.data}
        />
      ) : (
        <div style={{ padding: 24 }}>
          <h3>Integration page is unavailable.</h3>
        </div>
      )}
      {!isGoogleCalendarPage && (
        <div style={{
          position: 'absolute',
          top: 100,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(128, 128, 128, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          height: '81vh'
        }}>
          <h2 style={{ color: 'white', textAlign: 'center' }}>This page is a work in progress/beta</h2>
        </div>
      )}
    </div>
  );
};

export default IntegrationHeader;
